import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './auth.css';
import { getAccessToken } from '../auth';
import { Logger } from '@elyx-code/common-ts-utils';
import { envConfig } from '../config';
import { useWorkspaceStore } from '../store/workspace';

const NewPaymentMethodCallback: React.FC = () => {
	const navigate = useNavigate();

	const activeWorkspace = useWorkspaceStore((state) => state.activeWorkspace);

	const completePaymentMethodCreation = async () => {
		try {
			const session_id = new URL(window.location.href).searchParams.get(
				'session_id'
			);
			const token = await getAccessToken();

			const response = await axios.post(
				`${envConfig.API_BASE_URL}/pricing-service/v1/complete-add-payment-method-session?session_id=${session_id}`,
				{},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			const success = response.data;

			if (success.process === 'publish-project') {
				navigate(`/ws/${activeWorkspace?.slug}/editor/${success.projectId}/main/latest/publication/preview`);
			} else {
				navigate(`/ws/${activeWorkspace?.slug}/gallery`);
			}
		} catch (error) {
			// TODO: handle error
			Logger.error('error: ', error);
			navigate(`/ws/${activeWorkspace?.slug}/gallery`);
		}
	};

	useEffect(() => {
		completePaymentMethodCreation();
	}, []);

	return <div className='auth-page'></div>;
};

export default NewPaymentMethodCallback;
